import React, {Component} from 'react';
import {Col, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import Table from "../../../components/Table/Table";
import {showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import TextOverFlowTooltip from "../../../components/TextOverFlowTooltip";
import PostpaidCustomerDetail from "./PostpaidCustomerDetail";

class PostpaidCustomerList extends Component {

	constructor(props) {
		super(props);

		this.state = {
			postpaidCustomerList: [],
			loading: false,
			total: 0,
			page: 0,
			size: 10,
			manual: false,
			mode: 'list',
			isMobile : window.innerWidth > 991 ? false : true
		};

		this.closePostPaidCustomerListModal = this.closePostPaidCustomerListModal.bind(this);
		this.postpaidCustomerList = this.postpaidCustomerList.bind(this);
	}

	postpaidCustomerList(accessor, direction, page, size) {
		let self = this;
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc';
		let url = '/customer/fetchPostpaidCustomers?page=' + page + '&size=' + size + sortStr;
		let params = {
			url: url,
			method: "get"
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				self.setState({
					postpaidCustomerList: response.data.content,
					page: page,
					size: size,
					manual: false,
					loading: false,
					total: response.data.totalElements
				})
			}).catch(function (error) {
			showAxiosError(error);
			self.setState({manual: false, loading: false})
		});
	}

	closePostPaidCustomerListModal() {
		this.props.toggle()
	}

	redirectToSelectedCustomer(data) {
		this.props.history.push("/createEditCustomer/" + data.recordId.toString())
	}

	showDetails() {
		this.setState({
			mode: 'detail'
		})
	}

	render() {

		const {postpaidCustomerList,isMobile} = this.state;

		const columns = [
				{
					Header: "Vkn/Tckn",
					title: "Vkn/Tckn",
					accessor: "vknTckn",
					sortable: true
				},
				{
					Header: "Unvan",
					title: "Unvan",
					accessor: "formattedName",
					sortable: true,
					Cell: (row) => (
						<div>
							<TextOverFlowTooltip text={!isMobile ? row.formattedName : row.formattedName ? row.formattedName : "-"} maxLength={20}/>
						</div>
					)
				},
				{
					Header: "Ad",
					title: "Ad",
					accessor: "givenName",
					sortable: true
				},
				{
					Header: "Soyad",
					title: "Soyad",
					accessor: "familyName",
					sortable: true
				},
				{
					Header: "İşlemler",
					title: "İşlemler",
					accessor: "",
					width: '10%',
					Cell: (row) => (
						<Col sm='12'>
							<Row>
								{/*<Col sm='6' style={{padding: '0', margin: '0'}}>*/}
									{/*<button className='simpleButton sEdit' onClick={() => this.showDetails()}/>*/}
								{/*</Col>*/}

								{/*ToDo: PostpaidCustomerDetail tamamlaninca asagidaki sm='6' yapilacak & yukaridaki comment ACILACAK*/}
								<Col sm='12' style={{padding: '0', margin: '0'}}>
									<button className='simpleButton redirect' onClick={() => this.redirectToSelectedCustomer(row)}/>
								</Col>
							</Row>
						</Col>
					)
				}
			]
		;

		return (
			<Modal isOpen={this.props.isOpen} size='lg'>
				<ModalHeader toggle={this.closePostPaidCustomerListModal}>Faturalı Müşteriler</ModalHeader>
				<ModalBody>
					<div className="col-sm-12 row" style={{right: '-15px'}}>
						{this.state.mode === 'list' &&
						<Table columns={columns}
							   content={postpaidCustomerList}
							   total={this.state.total}
							   page={this.state.page}
							   size={this.state.size}
							   manual={false}
							   loading={this.state.loading}
							   options={["5", "10", "20", "50", "100"]}
							   fetchData={this.postpaidCustomerList}
						/>}
						{this.state.mode === 'detail' &&
						<Col sm='12'>
							<Row style={{height: '300px', alignItems: 'center'}}>
								<Col sm='1' style={{margin: '0', padding: '0', textAlign: 'center'}}>
									<button className='backwardsArrow' />
								</Col>
								<Col sm='11'>
									<PostpaidCustomerDetail/>
								</Col>
							</Row>
						</Col>}
					</div>
				</ModalBody>
			</Modal>
		)
	}
}

export default PostpaidCustomerList;